import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getPolicySettings,
  setCancellationPolicy,
  setLandlordPolicy,
} from '@/backend/services/policySettings';
import type { PolicyKey } from '@/shared/types/policySettings';

export function usePolicySettings() {
  return useQuery({
    queryKey: ['policy-settings'],
    queryFn: getPolicySettings,
    staleTime: 5 * 60 * 1000,
  });
}

interface UploadVars {
  key: PolicyKey;
  file: File;
  updatedBy: string;
  onProgress?: (progress: number) => void;
}

export function useUploadPolicy() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, file, updatedBy, onProgress }: UploadVars) =>
      key === 'cancellation'
        ? setCancellationPolicy({ file, updatedBy, onProgress })
        : setLandlordPolicy({ file, updatedBy, onProgress }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['policy-settings'] });
    },
  });
}
